import { useWizard } from "react-use-wizard";
import { TKeyOfDataWizardSell, TStringKeysOfIFillDataWizardSell } from "../..";
import { EDealRequestTimeInterval } from "../../../../../../shared/wizard/steps/types";
import sellSteps from "../sellSteps";
import TimeIntervalStep from "../../../../../../shared/wizard/steps/timeIntervalStep";

interface IKnowPriceStep_3 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardSell) => void;
  data: EDealRequestTimeInterval | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const KnowPriceStep_3 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IKnowPriceStep_3) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.knowPrice.step_2);
    onReset(["timeIntervalTypeCommunication"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.knowPrice.step_4);
  };

  const handleChange = (
    data: string,
    key: "timeIntervalTypeView" | "timeIntervalTypeCommunication"
  ) => {
    if(key === "timeIntervalTypeCommunication"){
      onChange(data, key);
    }
  };

  return (
    <div>
      <TimeIntervalStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={handleChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="communication"
        text="Удобное время для связи:"
      />
    </div>
  );
};

export default KnowPriceStep_3;
